export default __webpack_public_path__ + "static/media/crustaceos.f30f1b09.svg";